const Filled = () => (
    <span className="h-4 w-4 bg-[black] rounded-full border-[black] border">
    </span>
)

const Regular = () => (
    <span className="h-4 w-4 border-[black] rounded-full border">

    </span>
)

export const Attributes = ({ leftAttribute, personalityAttribute, rightAttribute }) => {
    const marks = [1, 2, 3, 4, 5, 6, 7];

    return (
        <article className="flex flex-row gap-4">
            <span>{leftAttribute}</span>
            {marks.map((el, index) => (
                <div className="flex flex-col gap-1 items-center" key={index}>
                    {el === personalityAttribute ? (<Filled />) : (<Regular />)}
                    <span className="text-xs">{el}</span>
                </div>
            ))}
            <span>{rightAttribute}</span>
        </article>
    )
}